import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 500,
    maxHeight: '80vh'
  },
  modalHeader: {
    marginBottom: theme.spacing(6)
  },
  modalContent: {
    marginBottom: theme.spacing(6),
    lineHeight: 1.5
  },
  content: {
    maxHeight: 'calc(80vh - 200px)',
    overflowY: 'auto'
  }
}));

export default useStyles;
